import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=ddc5851c&scoped=true&"
import script from "./ProductsList.vue?vue&type=script&lang=js&"
export * from "./ProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductsList.vue?vue&type=style&index=1&id=ddc5851c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc5851c",
  null
  
)

export default component.exports